import type { ImageResolveJobStatus } from '../hooks/useCatalogImageResolveJobInbox';

export const CATALOG_IMAGE_INBOX_OWNER = 'catalog';

export function catalogImageResolveAckType(status: ImageResolveJobStatus): string {
  if (status === 'PENDING' || status === 'RUNNING') return 'CATALOG_IMAGE_RESOLVE_ACTIVE';
  if (status === 'COMPLETED') return 'CATALOG_IMAGE_RESOLVE_COMPLETED';
  return 'CATALOG_IMAGE_RESOLVE_ACTIVE';
}
